import React from "react";

import HashIcon from "@uui/Hash02";
import { find, isEmpty } from "lodash/fp";

import { SelectChangeEvent, Typography } from "@mui/material";

import type { IntegrationConversation } from "@app/common/types";

import Dropdown, { DropdownMenuItem } from "@rui/Dropdown";
import IconBackground from "@rui/IconBackground";
import Stack, { Row } from "@rui/Stack";

const ChannelItemLabel = ({ name }: { name: string }) => (
  <Row variant="left" spacing={1}>
    <IconBackground
      height={19}
      sx={{ backgroundColor: "shades.neutral.50", color: "shades.neutral.500" }}
    >
      <HashIcon sx={{ paddingLeft: "1px" }} />
    </IconBackground>
    <Typography variant="bodySecondaryReg" color="shades.neutral.600">
      {name}
    </Typography>
  </Row>
);

const IntegrationChannelSelector = ({
  channels,
  disabled = false,
  onChange,
  placeholder = "Select channel",
  selected,
}: {
  channels: IntegrationConversation[];
  disabled?: boolean;
  onChange: (channel: IntegrationConversation | null) => void;
  placeholder?: string;
  selected: IntegrationConversation | null;
}) => {
  const handleChannelChange = (event: SelectChangeEvent) => {
    const channelId = event.target.value;
    const channel = find({ id: channelId }, channels) ?? null;
    onChange(channel);
  };

  const selectedItem = selected
    ? {
        label: selected.name,
        value: selected.id,
      }
    : undefined;

  const isDropdownDisabled = disabled || isEmpty(channels);

  return (
    <Stack spacing={1}>
      <Typography variant="bodyPrimaryMed" color="shades.neutral.800">
        Post to
      </Typography>
      <Dropdown
        name="channel-select"
        onChange={handleChannelChange}
        disabled={isDropdownDisabled}
        placeholder={placeholder}
        selectedItem={selectedItem}
        renderSelectedItem={(item) =>
          item?.label && <ChannelItemLabel name={item.label} />
        }
      >
        {channels.map((channel) => (
          <DropdownMenuItem
            key={channel.id}
            label={<ChannelItemLabel {...channel} />}
            value={channel.id}
          />
        ))}
      </Dropdown>
    </Stack>
  );
};

export default IntegrationChannelSelector;
